import { logger } from '../logger';
import { isDev } from '../utils/env';

import * as resolvers from './resolvers';

export type TExperimentNames = keyof typeof resolvers;
export type TExperimentReturn<T extends TExperimentNames> = ReturnType<
  (typeof resolvers)[T]
>;

const experimentResultCache = new Map<TExperimentNames, any>();

export const resetExperimentCache = (
  experimentName: TExperimentNames,
): void => {
  experimentResultCache.delete(experimentName);
};

export const resetAllExperimentsCache = (): void =>
  experimentResultCache.clear();

export const getExperiment = <T extends TExperimentNames>(
  experimentName: T,
): TExperimentReturn<T> | undefined => {
  try {
    if (!experimentResultCache.has(experimentName)) {
      const result = resolvers[experimentName]() as TExperimentReturn<T>;
      experimentResultCache.set(experimentName, result);
      logger.info(`experiment_${experimentName}`, { result });
      return result;
    }

    return experimentResultCache.get(experimentName);
  } catch (err) {
    logger.error('experiment_resolver_does_not_exist', { experimentName });
  }
};

// Test and Dev tools below here
export const experimentTesting = {
  /* istanbul ignore next - testing tool */
  getFromCache: <T extends TExperimentNames>(
    experimentName: T,
  ): TExperimentReturn<T> | undefined =>
    experimentResultCache.get(experimentName),
  /* istanbul ignore next - testing tool */
  setExperiment: <T extends TExperimentNames>(
    experimentName: T,
    value: TExperimentReturn<T>,
  ): void => {
    experimentResultCache.set(experimentName, value);
  },
};

/* istanbul ignore next - dev tools */
if (isDev) {
  // @ts-expect-error
  globalThis.ppExperiments = {
    experimentTesting,
    getExperiment,
    resetAllExperimentsCache,
    resetExperimentCache,
    resolvers,
  };
}
